// extracted by mini-css-extract-plugin
module.exports = {"clear-button":"_BaseInput_clear-button_3xd5D","clear-button-icon":"_BaseInput_clear-button-icon_2O_56","clear-button-default":"_BaseInput_clear-button-default_QDEpC"};